<template>
	<div style="width: 100vw;"
	:style="{
		minHeight:`calc(100vh - ${placeNavHeight}px)`
	}"
	>
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>
		<div v-if="data" 
			:style="equipment == 'pc'?{
			 		// width:equipment == 'pc'?'1280px':'100%'
			 		...boxStyleOne,
					minHeight:`calc(100vh - ${placeNavHeight})px`
			 	}:{
			 		width:'calc(96% - 20px)',
					minHeight:'calc(100vh - ' + placeNavHeight + 'px)'
			 	}" 
			 style="background-color: #fff;margin: auto;display: flex;flex-direction: column;align-items: center;padding: 20px 0px;margin-top: 30px;">
			<i style="color: #71c20b;font-size: 72px;font-weight: bold;" class="el-icon-circle-check"></i>
			<div style="margin-top: 20px;">
				<!-- Thank you for your order! -->
				{{$t('h.tkyouorder')}}
			</div>
			<div :style="{
				width: equipment == 'pc'?'60%':'calc(96%)',
				
			}" style="margin-top: 20px;padding: 5px;">
				<div style="display: flex;justify-content: space-between;">
					<div style="display: flex;align-items: center;">
						<span style="width: 6px;height: 14px;background-color: #635bff;margin-right: 10px;"></span>Order Details
					</div>
					<div style="border-radius: 10px;padding: 6px 6px;color: #fff;background-color: #fd560f ;font-size: 14px;cursor: pointer;" @click="dialogVisible = true">查看更多</div>
				</div>
				<div style="display: flex;justify-content: space-between;margin-top: 20px;" :style="{
					flexDirection:equipment == 'pc'?'row':'column'
				}">
					<div style="margin-top: 6px;display: flex;">
						<div>
							{{$t('h.orderId')}}:
						</div>
						<div  style="margin-left: 4px;" :style="{
							marginTop:equipment == 'pc'?'0px':'0px'
						}">{{data.order.number}}</div>
					</div>
					<div style="margin-top: 6px;display: flex;margin-left: 10px;">
						<div>
							{{$t('h.orderDate')}}
							<!-- Order Date: -->
						</div>
						<div  style="margin-left: 4px;" :style="{
							marginTop:equipment == 'pc'?'0px':'0px'
						}">{{data.order.created_at}}</div>
					</div>
					<div style="margin-top: 6px;display: flex;margin-left: 10px;">
						<div>
							{{$t('h.status_format')}}:
						</div>
						<div  style="margin-left: 4px;" :style="{
							marginTop:equipment == 'pc'?'0px':'0px'
						}">{{data.order.status_format}}</div>
					</div>
					<div style="display: flex;margin-top: 6px;margin-left: 10px;">
						<div>
							{{$t('h.ordeAmount')}}
							<!-- Order Amount: -->
						</div>
						<div style="margin-left: 4px;" :style="{
							marginTop:equipment == 'pc'?'0px':'0px'
						}" >{{data.order.total_format}}</div>
					</div>
				</div>
				<div style="display: flex;align-items: center;margin-top: 30px;">
					<span style="width: 6px;height: 14px;background-color: #635bff;margin-right: 10px;"></span>{{$t('h.addressInfo')}}
				</div>
				<div style="display: flex;align-items: center;justify-content: space-between;margin-top: 20px;border-bottom: solid 1px #dadada ;padding-bottom: 10px;">
					<div>{{$t('h.addressInfo')}}</div>
					<!-- Payment Address -->
					<div> {{$t('h.paymentAddress')}}</div>
				</div>
				<div style="display: flex;align-items: center;justify-content: space-between;">
					<div>
						<div style="display: flex;margin-top: 10px;align-items: center;">
							<div>{{$t('h.name')}}：{{data.order.shipping_customer_name}}</div>
							<div></div>
						</div>
						<div style="display: flex;margin-top: 10px;align-items: center;">
							<div>{{$t('h.address')}}：</div>
							<div>{{data.order.shipping_address_1}}  {{data.order.shipping_address_2}}</div>
						</div>
						<div style="display: flex;margin-top: 10px;align-items: center;">
							<div>{{$t('h.zipCode')}}：</div>
							<div>{{data.order.shipping_zipcode}}</div>
						</div>
					</div>
					<div>
						<div style="display: flex;margin-top: 10px;align-items: center;">
							<div>{{$t('h.name')}}：{{data.order.payment_customer_name}}</div>
							<div></div>
						</div>
						<div style="display: flex;margin-top: 10px;align-items: center;">
							<div>{{$t('h.address')}}：</div>
							<div>{{data.order.payment_address_1}}  {{data.order.payment_address_2}}</div>
						</div>
						<div style="display: flex;margin-top: 10px;align-items: center;">
							<div>{{$t('h.zipCode')}}：</div>
							<div>{{data.order.payment_zipcode}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		
		<el-dialog v-if="equipment == 'pc'" :title="$t('h.orderDetail')" :visible.sync="dialogVisible"
			:width="equipment == 'pc'?'60%':'96%'" :before-close="()=>{dialogVisible = false}">
			<div v-loading="detailLoading" style="width: 100%;min-height: 400px;overflow-x: scroll;">
				<div v-if="data" :style="{
					width:equipment == 'pc'?'100%' :'1000px'
				}">
					<div style="width: 90%;margin: auto;display: flex;align-items: center;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.orderDetail')}}</div>
					</div>
					<div
						style="display: flex;align-items: center;width: 90%;justify-content: space-between;background-color: #f8f9fa;padding: 10px;color: #000;margin: auto;margin-top: 10px;">
						<div>
							<div>{{$t('h.orderId')}}</div>
							<div style="margin-top: 6px;">{{data.order.number}}</div>
						</div>
						<div>
							<div>{{$t('h.created_at')}}</div>
							<div style="margin-top: 6px;">{{data.order.created_at}}</div>
						</div>
						<div>
							<div>{{$t('h.status_format')}}</div>
							<div style="margin-top: 6px;">{{data.order.status_format}}</div>
						</div>
						<div>
							<div>{{$t('h.total_format')}}</div>
							<div style="margin-top: 6px;">{{data.order.total_format}}</div>
						</div>
						<div>
							<div>{{$t('h.payment_method_name')}}</div>
							<div style="margin-top: 6px;">{{data.order.payment_method_name}}</div>
						</div>
						<div>
							<div>{{$t('h.shipping_method_name')}}</div>
							<div style="margin-top: 6px;">{{data.order.shipping_method_name}}</div>
						</div>
					</div>
		
					<div style="width: 90%;margin: auto;display: flex;align-items: center;margin-top: 20px;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.addressInfo')}}</div>
					</div>
					<div style="width: 90%;margin: auto;margin-top: 10px;">
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 50%;">
								<div>{{$t('h.sippingAddress')}}</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.name')}}: </div>
									<div>{{data.order.shipping_customer_name}}</div>
								</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.address')}}:</div>
									<div>{{data.order.shipping_address_1}} {{data.order.shipping_address_2}}
										{{data.order.shipping_zone}} {{data.order.shipping_country}}
									</div>
								</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.emailCode')}}:</div>
									<div>{{data.order.shipping_zipcode}}</div>
								</div>
							</div>
							<div style="width: 50%;">
								<div>{{$t('h.payOrderAddress')}}</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.name')}}:</div>
									<div>{{data.order.payment_customer_name}}</div>
								</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.address')}}:</div>
									<div>{{data.order.payment_address_1}} {{data.order.payment_address_2}}
										{{data.order.payment_zone}} {{data.order.payment_country}}
									</div>
								</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.emailCode')}}:</div>
									<div>{{data.order.payment_zipcode}}</div>
								</div>
							</div>
						</div>
					</div>
					<div style="width: 90%;margin: auto;display: flex;align-items: center;margin-top: 20px;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.payGoods')}}</div>
					</div>
					<div style="width: 90%;margin: auto;margin-top: 10px;">
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div v-for="(item,index) in data.order.order_products" :key="index"
								style="display: flex;align-items: center;">
								<img :src="item.image" style="width: 90px;height: 90px;" />
								<div style="margin-left: 10px;">
									<div class="tit">{{item.name}}</div>
									<div style="display: flex;align-items: center;margin-top: 20px;">
										<div>{{item.price_format}}</div>
										<div style="margin-left: 10px;">x{{item.quantity}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="data.order.status =='shipped'"
						style="width: 90%;margin: auto;display: flex;align-items: center;margin-top: 20px;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.sendCompany')}}</div>
					</div>
		
					<div v-if="data.order.status =='shipped'" style="width: 90%;margin: auto;margin-top: 10px;">
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 15%;">
								<div style="color: #000;">{{$t('h.sendCompany')}}</div>
							</div>
							<div style="width: 70%;text-align: center;">
								<div style="color: #000;">{{$t('h.sendNum')}}</div>
							</div>
							<div style="width: 15%;">
								<div style="color: #000;">{{$t('h.updateTime')}}</div>
							</div>
						</div>
		
						<div v-for="(item,index) in data.order.order_shipments" :key="index"
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 15%;">
								<div style="color: #000;">{{item.express_company}}</div>
							</div>
							<div style="width: 70%;text-align: center;">
								<div style="color: #000;">{{item.express_number}}</div>
							</div>
							<div style="width: 15%;">
								<div style="color: #000;">{{item.created_at}}</div>
							</div>
						</div>
					</div>
		
					<div style="width: 90%;margin: auto;display: flex;align-items: center;margin-top: 20px;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.status_format')}}</div>
					</div>
					<div style="width: 90%;margin: auto;margin-top: 10px;">
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 15%;">
								<div style="color: #000;">{{$t('h.status_format')}}</div>
							</div>
							<div style="width: 70%;text-align: center;">
								<div style="color: #000;">{{$t('h.memo')}}</div>
							</div>
							<div style="width: 15%;">
								<div style="color: #000;">{{$t('h.updateTime')}}</div>
							</div>
						</div>
		
						<div v-for="(item,index) in data.order.order_histories" :key="index"
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 15%;">
								<div style="color: #000;">{{item.status_format}}</div>
							</div>
							<div style="width: 70%;text-align: center;">
								<div style="color: #000;">{{item.comment}}</div>
							</div>
							<div style="width: 15%;">
								<div style="color: #000;">{{item.updated_at}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
		
		<el-dialog v-if="equipment == 'phone'" :title="$t('h.orderDetail')" :visible.sync="dialogVisible"
			:width="equipment == 'pc'?'60%':'96%'" :before-close="()=>{dialogVisible = false}">
			<div v-loading="detailLoading" style="width: 100%;min-height: 400px;overflow-x: scroll;">
				<div v-if="data" :style="{
					width:equipment == 'pc'?'100%' :'100%'
				}">
					<div style="width: 90%;margin: auto;display: flex;align-items: center;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.orderDetail')}}</div>
					</div>
					<div
						style="display: flex;width: 90%;background-color: #f8f9fa;padding: 10px;color: #000;margin: auto;margin-top: 10px;flex-direction: column;">
						<div style="display: flex;align-items: center;margin-top: 6px;">
							<div>{{$t('h.orderId')}}</div>
							<div style="margin-left: 10px;">{{data.order.number}}</div>
						</div>
						<div style="display: flex;align-items: center;margin-top: 6px;">
							<div>{{$t('h.created_at')}}</div>
							<div style="margin-left: 10px;">{{data.order.created_at}}</div>
						</div>
						<div style="display: flex;align-items: center;margin-top: 6px;">
							<div>{{$t('h.status_format')}}</div>
							<div style="margin-left: 10px;">{{data.order.status_format}}</div>
						</div>
						<div style="display: flex;align-items: center;margin-top: 6px;">
							<div>{{$t('h.total_format')}}</div>
							<div style="margin-left: 10px;">{{data.order.total_format}}</div>
						</div>
						<div style="display: flex;align-items: center;margin-top: 6px;">
							<div>{{$t('h.payment_method_name')}}</div>
							<div style="margin-left: 10px;">{{data.order.payment_method_name}}</div>
						</div>
						<div style="display: flex;align-items: center;margin-top: 6px;">
							<div>{{$t('h.shipping_method_name')}}</div>
							<div style="margin-left: 10px;">{{data.order.shipping_method_name}}</div>
						</div>
					</div>
		
		
		
					<div style="width: 90%;margin: auto;display: flex;align-items: center;margin-top: 20px;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.addressInfo')}}</div>
					</div>
					<div style="width: 90%;margin: auto;margin-top: 10px;">
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 100%;">
								<div>{{$t('h.sippingAddress')}}</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.name')}}: </div>
									<div>{{data.order.shipping_customer_name}}</div>
								</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.address')}}:</div>
									<div>{{data.order.shipping_address_1}} {{data.order.shipping_address_2}}
										{{data.order.shipping_zone}} {{data.order.shipping_country}}
									</div>
								</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.emailCode')}}:</div>
									<div>{{data.order.shipping_zipcode}}</div>
								</div>
							</div>
						</div>
					</div>
					
					<div style="width: 90%;margin: auto;margin-top: 10px;">
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							
							<div style="width: 100%;">
								<div>{{$t('h.payOrderAddress')}}</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.name')}}:</div>
									<div>{{data.order.payment_customer_name}}</div>
								</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.address')}}:</div>
									<div>{{data.order.payment_address_1}} {{data.order.payment_address_2}}
										{{data.order.payment_zone}} {{data.order.payment_country}}
									</div>
								</div>
								<div style="display: flex;align-items: center;margin-top: 6px;">
									<div>{{$t('h.emailCode')}}:</div>
									<div>{{data.order.payment_zipcode}}</div>
								</div>
							</div>
						</div>
					</div>
		
					<div style="width: 90%;margin: auto;display: flex;align-items: center;margin-top: 20px;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.payGoods')}}</div>
					</div>
					<div style="width: 90%;margin: auto;margin-top: 10px;">
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div v-for="(item,index) in data.order.order_products" :key="index"
								style="display: flex;align-items: center;">
								<img :src="item.image" style="width: 90px;height: 90px;" />
								<div style="margin-left: 10px;">
									<div class="tit">{{item.name}}</div>
									<div style="display: flex;align-items: center;margin-top: 20px;">
										<div>{{item.price_format}}</div>
										<div style="margin-left: 10px;">x{{item.quantity}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
		
					<div v-if="data.order.status =='shipped'"
						style="width: 90%;margin: auto;display: flex;align-items: center;margin-top: 20px;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.sendCompany')}}</div>
					</div>
					<div v-if="data.order.status =='shipped'" style="width: 90%;margin: auto;margin-top: 10px;">
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 15%;">
								<div style="color: #000;">{{$t('h.sendCompany')}}</div>
							</div>
							<div style="width: 60%;text-align: center;">
								<div style="color: #000;">{{$t('h.sendNum')}}</div>
							</div>
							<div style="width: 20%;">
								<div style="color: #000;">{{$t('h.updateTime')}}</div>
							</div>
						</div>
		
		
						<div v-for="(item,index) in data.order.order_shipments" :key="index"
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 15%;">
								<div style="color: #000;">{{item.express_company}}</div>
							</div>
							<div style="width: 60%;text-align: center;">
								<div style="color: #000;">{{item.express_number}}</div>
							</div>
							<div style="width: 25%;">
								<div style="color: #000;">{{item.created_at}}</div>
							</div>
						</div>
					</div>
					<div style="width: 90%;margin: auto;display: flex;align-items: center;margin-top: 20px;">
						<div style="width: 4px;height: 20px;background-color: #635bff;"></div>
						<div style="margin-left: 10px;">{{$t('h.status_format')}}</div>
					</div>
					<div style="width: 90%;margin: auto;margin-top: 10px;">
						<div
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 15%;">
								<div style="color: #000;">{{$t('h.status_format')}}</div>
							</div>
							<div style="width: 60%;text-align: center;">
								<div style="color: #000;">{{$t('h.memo')}}</div>
							</div>
							<div style="width: 20%;">
								<div style="color: #000;">{{$t('updateTime')}}</div>
							</div>
						</div>
		
						<div v-for="(item,index) in data.order.order_histories" :key="index"
							style="display: flex;justify-content: space-between;background-color: #f8f9fa;padding: 10px;">
							<div style="width: 15%;">
								<div style="color: #000;">{{item.status_format}}</div>
							</div>
							<div style="width: 60%;text-align: center;">
								<div style="color: #000;">{{item.comment}}</div>
							</div>
							<div style="width: 25%;">
								<div style="color: #000;">{{item.updated_at}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getCheckoutSuccessData
	} from '../../../api/all.js'
	export default {
		data() {
			return {
				dialogVisible:false,
				loading: false,
				data: null
			}
		},
		props: {
			boxStyleTwo: {
				type: Object,
				default: () => {
					return {}
				}
			},
			boxStyleOne: {
				type: Object,
				default: () => {
					return {}
				}
			},
			placeNavHeight: {
				type: Number,
				default: 0
			},
			equipment: {
				type: String,
				default: "pc"
			},
			localPageData: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		mounted() {
			this.getData()
		},
		methods: {
			async getData() {
				try {
					this.loading = true
					console.log('$router$router$router132', this.$route)
					const data = await getCheckoutSuccessData({
						order_number: this.$route.params.id
					})
					this.data = data.data.data
					console.log('data', data)
					this.loading = false
				} catch (e) {
					this.loading = false
				}
			}
		}
	}
</script>

<style>
</style>